const formats: Record<string, Intl.NumberFormat> = {};
export const pt = (options: Intl.NumberFormatOptions) => (formats[JSON.stringify(options)] ??= new Intl.NumberFormat("pt-BR", options));

export function formatRatio(value: number): string {
  const digits = Math.abs(roundTo(value, 2)) >= 10 ? 1 : 2;
  return minus(pt({ minimumFractionDigits: digits, maximumFractionDigits: digits }).format(value));
}

export function formatPercent(fraction: number, options: { readonly sign?: boolean; readonly whole?: boolean } = {}): string {
  const size = Math.abs(roundTo(fraction * 100, 1));
  const digits = size >= (options.whole === true ? 1 : 10) ? 0 : 1;
  const sign = options.sign === true ? "exceptZero" : "auto";
  return minus(pt({ style: "percent", minimumFractionDigits: digits, maximumFractionDigits: digits, signDisplay: sign }).format(fraction));
}

export function formatNumber(count: number): string {
  return minus(pt({ maximumFractionDigits: 1 }).format(count));
}

export function formatFrequency(value: number): string {
  return pt({ minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(value);
}

export function minus(text: string): string {
  return text.replace("-", "−");
}

function roundTo(value: number, decimals: number): number {
  const scale = 10 ** decimals;
  return Math.round(value * scale) / scale;
}
